<template>
  <div>
    <v-row v-if="!dialog" dense>
      <v-col cols="12" sm="6" md="3">
        <px-select-enum dense
                        v-model="negociacao.novaFormaPagemento"
                        :items="formasPagamentos"
                        @change="onChangeFormaPagamento"
                        class="rounded-tag-small"
                        label="Forma de pagamento"/>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <px-autocomplete-prazo-pagamento
          dense
          label="Prazo de pagamento"
          :class="isAVista ? 'rounded-tag-small' : 'required rounded-tag-small'"
          :disabled="isAVista"
          :error="$v.negociacao.novoPrazoPagamento.$error"
          @blur="$v.negociacao.novoPrazoPagamento.$touch()"
          v-model="negociacao.novoPrazoPagamento"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <px-select-enum dense
                        label="Tipo de frete"
                        class="rounded-tag-small"
                        v-model="negociacao.novoTipoFrete"
                        :items="tiposFretes"/>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <px-input-number dense
                         label="Prazo de embarque (Dias úteis)"
                         class="rounded-tag-small"
                         v-model="negociacao.novoPrazoEntrega"/>
      </v-col>
    </v-row>
    <v-row v-if="dialog" dense>
      <v-col cols="12" sm="6">
        <px-select-enum v-model="negociacao.novaFormaPagemento"
                        :items="formasPagamentos"
                        @change="onChangeFormaPagamento"
                        class="rounded-tag-small"
                        label="Forma de pagamento"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-prazo-pagamento
          label="Prazo de pagamento"
          :class="isAVista ? 'rounded-tag-small' : 'required rounded-tag-small'"
          :disabled="isAVista"
          :error="$v.negociacao.novoPrazoPagamento.$error"
          @blur="$v.negociacao.novoPrazoPagamento.$touch()"
          v-model="negociacao.novoPrazoPagamento"
        />
      </v-col>
    </v-row>
    <v-row v-if="dialog" dense>
      <v-col cols="12" sm="6">
        <px-select-enum label="Tipo de frete"
                        class="rounded-tag-small"
                        v-model="negociacao.novoTipoFrete"
                        :items="tiposFretes"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-input-number label="Prazo de embarque (Dias úteis)"
                        class="rounded-tag-small"
                        v-model="negociacao.novoPrazoEntrega"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormaPagamento, TipoFrete } from 'px-business-components';
import { requiredIf } from 'vuelidate/lib/validators';

export default {
  props: {
    negociacao: Object,
    dialog: Boolean,
  },
  data() {
    return {
      tiposFretes: TipoFrete.values,
      formasPagamentos: FormaPagamento.values,
    };
  },
  computed: {
    isAVista() {
      return this.negociacao.novaFormaPagemento !== FormaPagamento.keys.A_PRAZO.key;
    },
  },
  methods: {
    onChangeFormaPagamento() {
      this.negociacao.novoPrazoPagamento = null;
    },
  },
  validations: {
    negociacao: {
      novoPrazoPagamento: {
        required: requiredIf(function () {
          return !this.isAVista;
        }),
      },
    },
  },
};
</script>
